/**
 * Componente EmptyState
 * 
 * Exibe estados vazios de forma consistente em toda a aplicação
 */

import React from 'react';

const EmptyState = ({
  icon = '📦',
  title = 'Nada encontrado',
  message = 'Não há itens para exibir no momento.',
  actionLabel = null,
  onAction = null,
  className = '',
}) => {
  const containerClasses = `flex flex-col items-center justify-center py-12 px-4 text-center ${className}`.trim();
  
  return (
    <div
      className={containerClasses}
      role="status"
      aria-live="polite"
    >
      {/* Ícone */}
      <div
        className="text-6xl mb-4"
        role="img"
        aria-label={title}
      >
        {icon}
      </div>

      {/* Título */}
      <h3 className="text-xl font-semibold text-gray-800 mb-2">
        {title}
      </h3>

      {/* Mensagem */}
      <p className="text-gray-600 mb-6 max-w-md">
        {message}
      </p>

      {/* Ação opcional */}
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="px-6 py-2 bg-primary text-white rounded-lg font-medium hover:bg-primary-dark transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
          aria-label={actionLabel}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;

